export default function (nga, admin, menu) {
    var _ename = 'products';
    var _epretty = 'Products';
    var _entity = nga.entity(_ename);
    
    _entity.listView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID'),
            nga.field('code').label('Code').isDetailLink(true),
            nga.field('name').label('Name').isDetailLink(true),
            nga.field('product_type_id', 'reference')
                .targetEntity(nga.entity('producttypes'))
                .targetField(nga.field('name'))
                .label('Product Type')
        ])
        .sortField('name')
        .sortDir('asc')
        .listActions(['edit', 'show']);

    _entity.showView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID'),
            nga.field('code').label('Code'),
            nga.field('name').label('Name'),
            nga.field('product_type_id', 'reference')
                .targetEntity(nga.entity('producttypes'))
                .targetField(nga.field('name'))
                .label('Product Type'),
            nga.field('product_geoblocks', 'reference_many')
                .targetEntity(nga.entity('countries'))
                .targetField(nga.field('name'))
                .label('Geoblock'),
            nga.field('attributes', 'embedded_list') 
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('name'),
                    nga.field('pivot.language'),
                    nga.field('pivot.value')
                ])
        ]);
        
    _entity.editionView()
        .title('Edit ' + _epretty)
        .fields([
            nga.field('code').label('Code'),
            nga.field('name').label('Name'),
            nga.field('product_type_id', 'reference')
                .validation({ required: true })
                .targetEntity(nga.entity('producttypes'))
                .targetField(nga.field('name'))
                .label('Product Type'),
            nga.field('product_geoblocks', 'reference_many')
                .targetEntity(nga.entity('countries'))
                .targetField(nga.field('name'))
                .label('Geoblock')
        ]);
        
    _entity.creationView()
        .title('Create new ' + _epretty)
        .fields([
            nga.field('code').label('Code'),
            nga.field('name').label('Name'),
            nga.field('product_type_id', 'reference')
                .validation({ required: true })
                .targetEntity(nga.entity('producttypes'))
                .targetField(nga.field('name'))
                .label('Product Type'),
            nga.field('product_geoblocks', 'reference_many')
                .targetEntity(nga.entity('countries'))
                .targetField(nga.field('name'))
                .label('Geoblock')
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/product.js